// extracted by mini-css-extract-plugin
export default {"infoImg":"InfoProjectedBalance_infoImg__tg7VC"};